const games = [
  {
    id: 'chess',
    title: 'Chess',
    description: 'A classic strategy board game played on an 8x8 grid.',
    image: 'https://upload.wikimedia.org/wikipedia/commons/4/4f/ChessSet.jpg',
  },
  {
    id: 'sudoku',
    title: 'Sudoku',
    description: 'A logic-based, combinatorial number-placement puzzle.',
    image: 'https://upload.wikimedia.org/wikipedia/commons/e/e0/Sudoku_Puzzle_Hard_for_print.png',
  },
  // Add more games as needed
];

export default games; 